const initialVisibilityState = {
  ownersVisible: false,
  userTasksHighlighted: false,
  versionControlPanelVisible: false,
  diagramPropertiesVisible: false,
  diagramVersionCommentVisible: true,
};

export default initialVisibilityState;
